module.exports = __webpack_public_path__ + "static/img/u70070.78e8f7a0.png";